import { useState } from "react";
import noimag from './../../assets/img/noimg.jpg';
import { STORAGE } from "../../utils/headers";

export default function UploadFile({setFile,currentImg}){

  const [image, setImage] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
  };

  return (
    <div style={styles.container}>
      <div style={styles.uploadBox}>
        {image ? (
          <img src={image} alt="Uploaded" style={styles.image} />
        ) : (
          <img
            src={currentImg?`${STORAGE}/${currentImg}`:noimag} // Imagen por defecto
            alt="Default"
            style={styles.image}
          />
        )}
        <input
          type="file"
          accept="image/*"
          style={styles.input}
          onChange={handleImageUpload}
        />
      </div>
      {image && (
        <button style={styles.deleteButton} onClick={handleRemoveImage}>
          <i className="fa fa-trash" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}

const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
    },
    uploadBox: {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
    },
    input: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      opacity: "0",
      cursor: "pointer",
    },
    image: {
      width: "150px",
      height: "150px",
      objectFit: "cover",
      borderRadius: "5px",
      border: "1px solid #ddd",
    },
    deleteButton: {
      background: "red",
      color: "white",
      border: "none",
      padding: "5px 10px",
      cursor: "pointer",
      borderRadius: "5px",
    },
  };